<template>
  <nav-bar title="钢瓶详细信息" />
  <Content :bottom="0">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <van-cell-group title="流转查询">
      <van-cell
        title="选择起止时间"
        :value="currDate"
        is-link
        @click="handleSelectDate"
      />
    </van-cell-group>

    <!--
          :max-date="new Date()"
      :min-date="minDate"
    -->
    <van-calendar
      v-model:show="show"
      :max-date="new Date()"
      :min-date="minDate"
      type="range"
      ref="calender"
      :default-date="null"
      @confirm="onConfirm"
      :lazy-render="false"
    />
    <van-cell-group title="钢瓶基本信息">
      <van-cell title="登记证编号" :value="baseMess.regId" />
      <van-cell title="产品编号" :value="baseMess.gsCode" />
      <van-cell title="气瓶品种" :value="baseMess.gsTypeName" />
      <van-cell
        title="充装介质"
        :value="baseMess.gsGoodsName || fillMess.goodsName"
      />
      <van-cell title="制造单位" :value="baseMess.makeUnitName" />
      <van-cell title="制造日期" :value="baseMess.makeDate" />
      <van-cell title="公称压力（MPa）" :value="baseMess.gsPressure" />
      <van-cell title="容积（L）" :value="baseMess.gsCapacity" />
      <van-cell title="检验日期" :value="baseMess.checkDate" />
      <van-cell title="下次检验日期" :value="baseMess.nextCheckDate" />
      <van-cell title="气瓶状态" :value="baseMess.gsStatusName" />
      <van-cell title="气瓶属性" :value="baseMess.custodyFlagName" />
      <van-cell title="托管单位" :value="baseMess.custodyUnit" />
      <van-cell title="钢瓶照片" :url="baseMess.url" is-link />
      <!-- <van-cell title="当前位置" :value="baseMess.companyName" /> -->
    </van-cell-group>
    <UserMap
      v-if="!isLoading && !showLoading"
      :point="baseMess"
      :title="baseMess.location || ''"
    />
    <van-cell-group title="钢瓶充装信息">
      <van-cell title="充装单位" :value="fillMess.companyName" />
      <van-cell title="充装时间" :value="fillMess.fillDate" />
      <van-cell title="充装人员" :value="fillMess.userName" />
      <van-cell title="充装重量" :value="fillMess.capacity" />
    </van-cell-group>
    <van-cell-group title="许可证信息">
      <!--       <van-collapse   v-model="cList"  v-for="item in cList" :key="item.id">-->
      <!--         <van-collapse-item :title="item.manDesc" :name="item.id" >-->
      <!--           <van-image width="100px;" height="100px;" :src="item.manUrl" />-->
      <!--         </van-collapse-item>-->
      <!--       </van-collapse>-->
      <van-cell
        v-for="(item, index) in cList"
        :key="index"
        :title="item.manDesc"
        :url="item.manUrl"
        is-link
      />
    </van-cell-group>
  </Content>
  <Trajectory ref="trajectory" :pointList="pointList" />
</template>

<script>
import { ref, computed, nextTick } from 'vue'
import { getCylinderInfoMess, getCylinderTrackList } from '@/api/cylinderInfo'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useStore } from 'vuex'
import { useGetData } from '@/hooks/useGetData'
import Trajectory from './trajectory.vue'
import { Toast } from 'vant'
export default {
  name: 'CylinderInfo', // 钢瓶查询结果
  components: { Trajectory },
  props: ['id'],
  setup(props) {
    const cList = ref([])
    const baseMess = ref({})
    const fillMess = ref({})
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    // 获取钢瓶信息
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getCylinderInfoMess,
      (data) => {
        baseMess.value = data.baseMess
        fillMess.value = data.fillMess
        cList.value = data.certificateList
      },
      props.id
    )
    getDataLoading()

    // 选择日期
    const currDate = ref('选择起止时间')
    const show = ref(false)
    const date = new Date()

    const formatDate = (date) => {
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      const day = date.getDate()
      switch (month) {
        case 1:
        case 2:
        case 3:
          month += 9
          year--
          break
        default:
          month -= 3
          break
      }
      return year + '/' + month + '/' + day
    }
    const formatDate2 = (date) => {
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    }
    const calender = ref(null)
    // calender.value.scrollToDate(new Date('2021/12/21'))
    const handleSelectDate = () => {
      show.value = true
      nextTick(() => {
        calender.value.scrollToDate(new Date())
      })
    }
    const minDate = new Date(formatDate(date))
    const onConfirm = (value) => {
      const arr = value.map((item) => formatDate2(item))
      currDate.value = arr[0] + '/' + arr[1]
      getPointList({
        cylinderId: props.id,
        stDate: arr[0],
        endDate: arr[1]
      })
      show.value = false
    }
    // 获取钢瓶轨迹
    const trajectory = ref(null)
    const pointList = ref([])
    const getPointList = (params) => {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        overlay: true,
        message: '请稍后...'
      })
      useGetData(getCylinderTrackList, (data) => {
        Toast.clear()
        pointList.value = data
        trajectory.value.showPopup()
      })(params)
    }
    return {
      getDataLoading,
      isLoading,
      showLoading,
      baseMess,
      fillMess,
      cList,
      companyId,
      currDate,
      show,
      onConfirm,
      minDate,
      trajectory,
      pointList,
      calender,
      handleSelectDate
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-bottom: 16px;
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
.search-btn {
  background-color: #fff;
  padding: 16px;
  .search-btn-content {
    background-color: #f8f8f8;
    font-size: 14px;
    padding: 10px 5px;
    color: #666;
    text-align: center;
  }
}
</style>
